import 'core-js/stable';

import AlertBar from '@/components/AlertBar';

document.addEventListener('DOMContentLoaded', function () {
    /*example componentized script 
    (runs script for each element in document.querySelectorAll(selector)); */

    AlertBar.init({
        selector: `[data-js="alert-bar"]`,
    });
});
